import { NavLink, Tooltip, useMantineTheme } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';
import { tKeys, useTranslation } from 'locales';
import { useHistory } from 'react-router-dom';
import { find, isDefined, isNonNullish, map, pipe } from 'remeda';
import { UpsellFeatureSchema } from '../../Upsell/types';
import type { Menu } from '../types';
import { MenuItemBadges } from './MenuItemBadges';
import { styles } from './NavMenuItem';

interface NavMenuProps {
  menu: Menu;
  setMenu: (menu: Menu) => void;
}

export const NavMenu = ({ menu, setMenu }: NavMenuProps) => {
  const theme = useMantineTheme();
  const history = useHistory();
  const { t } = useTranslation();

  if (menu.isHidden) return null;

  const { showUpsell = false } = menu;

  const upsellFeature = pipe(
    (menu.path ?? '').split('/').reverse(),
    map(s => s.replace(/-/g, '')),
    find(s => UpsellFeatureSchema.safeParse(s).success),
  );
  const isUpsellPath = showUpsell && isNonNullish(upsellFeature);

  const handleClick = () => {
    if (isUpsellPath) {
      history.push(`/upgrade/${upsellFeature}`);
      return;
    }
    if (showUpsell) return;
    setMenu(menu);
    if (isDefined(menu.path)) history.push(menu.path);
  };

  return (
    <Tooltip label={t(tKeys.NAV.UPSELL)} position="right" offset={20} disabled={!showUpsell}>
      <NavLink
        onClick={handleClick}
        label={menu.label}
        classNames={{ root: styles.navLinkRoot(showUpsell) }}
        leftSection={
          <menu.Icon
            style={{ opacity: showUpsell ? '0.4' : '' }}
            color={theme.colors.purple[5]}
            stroke="1.7"
            size={20}
          />
        }
        rightSection={
          showUpsell ? (
            <MenuItemBadges showUpsell={showUpsell} />
          ) : (
            <IconChevronRight color={theme.colors.gray[8]} size={16} />
          )
        }
      />
    </Tooltip>
  );
};
